import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useGetTeamsQuery } from "../../features/teams/teamsApi";
import { hexToRgb } from "../../utils/hexToRgb";
import Error from "./../../components/ui/Error";
import Modal from "./modal";
import ModalAssigne from "./modalAssigne";

const Teams = () => {
  const { user } = useSelector((state) => state.auth) || {};
  const { email } = user || {};

  const { data: teams, isLoading, isError, error } = useGetTeamsQuery(email);

  // single team
  const [singleTeam, setSingleTeam] = useState("");

  // team modal
  const [opened, setOpened] = useState(false);
  const controlModal = () => {
    setOpened((prevState) => !prevState);
  };

  // modal assigne
  // modal
  const [openedAssigne, setOpenedAssigne] = useState(false);
  const controlModalAssigne = () => {
    setOpenedAssigne((prevState) => !prevState);
  };

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <h2 className="m-2 text-center">Loading...</h2>;
  } else if (!isLoading && isError) {
    content = (
      <div className="m-2 text-center">
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && teams?.length === 0) {
    content = <div className="m-2 text-center">No teams found!</div>;
  } else if (!isLoading && !isError && teams?.length > 0) {
    content = (
      <>
        {teams.map((itm, index) => {
          return (
            <div
              className="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
              draggable="true"
              key={index}
            >
              <button
                className="absolute top-0 right-0 flex items-center justify-center hidden w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex"
                onClick={() => {
                  controlModalAssigne();
                  setSingleTeam(itm);
                }}
              >
                <svg
                  className="w-4 h-4 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                </svg>
              </button>
              <span
                className="flex items-center h-6 px-3 text-xs font-semibold rounded-full"
                style={{
                  backgroundColor: `rgba(${hexToRgb(itm?.color).join()},.1)`,
                  color: `rgba(${hexToRgb(itm?.color).join()},.7)`,
                }}
              >
                {itm?.title}
              </span>
              <h4 className="mt-3 text-sm font-medium">{itm?.description}</h4>
              <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                <div className="flex items-center">
                  <svg
                    className="w-4 h-4 text-gray-300 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span className="ml-1 leading-none">
                    {moment(itm?.timestamp).fromNow()}
                  </span>
                </div>
              </div>
              <ul>
                {itm?.teamUsers?.length > 0 &&
                  itm?.teamUsers?.map((user, i) => {
                    return (
                      <li
                        key={i}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "5px",
                        }}
                      >
                        <div class="overflow-hidden relative w-5 h-5 bg-gray-100 rounded-full dark:bg-gray-600">
                          <svg
                            class="absolute -left-1 w-12 h-12 text-gray-400"
                            fill="currentColor"
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </div>
                        <span>{user.name}</span>
                      </li>
                    );
                  })}
              </ul>
            </div>
          );
        })}
      </>
    );
  }

  return (
    <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
      <div className="px-10 mt-6 flex justify-between">
        <h1 className="text-2xl font-bold">Teams</h1>
        <button
          className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
          onClick={controlModal}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            ></path>
          </svg>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto">
        {content}
      </div>

      {/* team create modal */}
      <Modal open={opened} control={controlModal} />

      {/* team assigne modal */}
      <ModalAssigne
        open={openedAssigne}
        control={controlModalAssigne}
        singleTeam={singleTeam}
        email={email}
      />
    </div>
  );
};

export default Teams;
